export enum PlayerJumpingStateConstants {
    None,
    One,
    Two,
    ForceDown
}